// import { SPAContainer, colors } from '@modules/ui-pack'

import {
  DescBlock,
  Description,
  Frame,
  InfoLink,
  Information,
} from '../../components/common'

import { Link } from 'gatsby'
import React from 'react'
import SVGLogoText from '../../images/icons/logo-current.svg'
import SVGLogoWhiteText from '../../images/icons/logo-text.svg'
import graphqlData from '../../graphql.js'

export const LinkSubTitle = (props, { children }) => (
  <a {...props} className='text-sm text-gray-600 lg:text-sm dark:text-gray-300'>
    {children}
  </a>
)

const Mailto = ({ email, children }) => {
  return <a href={`mailto:${email}`}>{children}</a>
}

// notionLink 다른 곳에도 있음. 같이 수정해주기
const notionLink = 'https://www.notion.so/strumus/About-a0fd71c3c496447db4326ddd97890ac1'

function Footer({ bgWhite = false }) {
  // const { setCurrentTab } = useUserPreferenceContext()
  const footerData = graphqlData()
  // console.log(footerData)

  const {
    allMarkdownRemark: { nodes },
  } = footerData

  const footerdata = nodes.filter(
    (data) => data.frontmatter.templateKey === 'footer-page',
  )?.[0]

  return (
    <Frame>
      <div className='flex flex-col py-12 space-x-0 lg:flex-row lg:space-x-32 '>
        <DescBlock>
          {
            bgWhite ? <img src={SVGLogoText}/> : <img src={footerdata.frontmatter.footer_image}/>
          }

          <Information white={!bgWhite}>{footerdata.frontmatter.footer_description}</Information>
        </DescBlock>
        <div className='flex flex-col space-x-0 space-y-10 lg:flex-row lg:space-x-10 lg:space-y-0'>
          <div className='flex flex-col items-start space-y-1 w-22'>
            <Description white={!bgWhite}>PRODUCT</Description>
            <Information white={!bgWhite}><Link to='/slack'>Slack integration</Link></Information>
            {/* <LinkSubTitle onClick={() => history.push('/product')}> Product </LinkSubTitle>
              <LinkSubTitle onClick={() => history.push('/demo')}> Demo </LinkSubTitle>
              <LinkSubTitle onClick={() => history.push('/slack')}> Slack app </LinkSubTitle> */}

          </div>
          <div className='flex flex-col items-start space-y-1 w-22'>
            <Description white={!bgWhite}>COMPANY</Description>
            <Information white={!bgWhite}><Link to={notionLink} target='_black'>About</Link></Information>
            <Information white={!bgWhite}><Link to='/terms'>Terms of service</Link></Information>
            <Information white={!bgWhite}><Link to='/privacy'>Privacy Policy</Link></Information>
            <a href='mailto:jang@strum.us' className={`text-sm $${!bgWhite ? 'text-gray-300' : ''} cursor-pointer lg:text-sm`}>Contact us</a>
            {/* <LinkSubTitle onClick={() => history.push('/terms')}> Terms of service </LinkSubTitle>
              <LinkSubTitle onClick={() => history.push('/privacy')}> Privacy policy </LinkSubTitle> */}
            <Mailto email={'service@strum.us'}><LinkSubTitle white={!bgWhite}> Support </LinkSubTitle></Mailto>

          </div>
        </div>
      </div>
      <Information white={!bgWhite}>
        © {new Date().getFullYear()} Copyright Strum Corp
      </Information>
      {/* </div> */}
    </Frame>
    // </section>
  )
}

export default Footer
